import React from "react";
import { ActionPlanListView } from "../../../amorg-common/DTOs/ActionPlanListView";
import { NoUserAvatar } from "../../../designSystem/avatar/NoUserAvatar";
import { UserAvatar } from "../../../designSystem/avatar/UserAvatar";
import { colors } from "../../../designSystem/colors/color";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Icon } from "../../../designSystem/icons/Icons";
import { PageSectionTable } from "../../../designSystem/PageSectionTable";
import { Small } from "../../../designSystem/typography/Body";
import { userUtils } from "../../../utils/userUtils";
import { InfoChip } from "../../../designSystem/Chip";
import { Button } from "../../../designSystem/button/Button";

export function ActionPlanListingPageSectionTable(props:{
    items:ActionPlanListView[],
    noContentText:string,
    onClick:(actionPlanId:string)=>void}
):JSX.Element
{
    return (
        <PageSectionTable
            headerColumns={[
                {text:'Status', gridDefinition:'220px'},
                {text:'Titel', gridDefinition:'minmax(0, 1fr)'},
                {text:'Type', gridDefinition:'180px'},
                {text:'Ansvarlig', gridDefinition:'80px'},
                {text:'', gridDefinition:'40px'}
            ]}
            noContentText={props.noContentText}
            showAllLimit={5}>

            {props.items.map(activity => {
                
                return (
                    <>
                        <StatusContent activity={activity} />

                        <TitleContent activity={activity} />

                        <TypeContent activity={activity} />

                        <OwnerContent activity={activity} />

                        <Button variant="text"
                            icon="arrows_chevron_chevronForward"
                            onClick={()=>props.onClick(activity.id)} />
                    </>
                );
            })}
        </PageSectionTable>
    );
}

function StatusContent(props:{activity:ActionPlanListView}):JSX.Element
{
    let primary = <></>

    if(props.activity.actionpointStats.total === 0)
        primary = <Flex alignItems="center" gap={4}><Icon name="quiz" color={colors.icon.passive} /><Small>Ingen handlepunkter</Small></Flex>;
    else {
        if(props.activity.actionpointStats.pastDeadline > 0)
            primary = <Flex alignItems="center" gap={4}><Icon name="status_error" color={colors.icon.error} /><Small>{props.activity.actionpointStats.pastDeadline + " handlepunkt(er) forfalden"}</Small></Flex>;
        else if(props.activity.actionpointStats.completed === props.activity.actionpointStats.total)
            primary = <Flex alignItems="center" gap={4}><Icon name="status_ok" color={colors.icon.success} /><Small>Alle handlepunkter afsluttet</Small></Flex>;
        else
            primary = <Flex alignItems="center" gap={4}><Icon name="warning" color={colors.icon.warning} /><Small>{props.activity.actionpointStats.pending + "/" + props.activity.actionpointStats.total +" handlepunkt(er) åbne"}</Small></Flex>;
    }

    return primary;
}

function TitleContent(props:{activity:ActionPlanListView}):JSX.Element
{
    return (
        <span>{props.activity.title}</span>
    );
}

function TypeContent(props:{activity:ActionPlanListView}):JSX.Element
{
    let chip = <InfoChip>Handleplan</InfoChip>;
    if(props.activity.activityType === 'WorkplaceAssessment')
        chip = <InfoChip>Arbejdspladsvurdering</InfoChip>;
    else if(props.activity.activityType === 'ArticleActionPlan')
        chip = <InfoChip>Lovkrav</InfoChip>;

    return <div>{chip}</div>;
}

function OwnerContent(props:{activity:ActionPlanListView}):JSX.Element
{
    if(props.activity.owner === null)
        return <NoUserAvatar />;

    return <UserAvatar user={{
        displayName: props.activity.owner.fullName,
        initials: userUtils.getInitials(props.activity.owner.fullName)
    }} />;
}